/**
 * Helper class for modifying CSS properties.
 */
angular.module('impactx.util')
    .factory("ixCssHelper", function () {
        return {
            /**
             * Searches the given element for sub-elements having the 'main' class and adds and/or removes some CSS class.
             *
             * @param elem element which direct sub-elements might have the 'main' class defined
             * @param mainCss 'main' class, the elements having it might be modified
             * @param classToAdd (optional)the name of the class to add (without leading ., i.e. row-elem instead of .row-elem)
             * @param classToRemove (optional)the name of the class to remove (without leading ., i.e. row-elem instead of .row-elem)
             */
            setSecondClass: function (elem, mainCss, classToAdd, classToRemove) {
                var idx, elementChildren, singleSubElem;

                elementChildren = elem.children();

                for (idx = 0; idx < elementChildren.length; idx++) {

                    singleSubElem = angular.element(elementChildren[idx]);

                    if (singleSubElem && singleSubElem.hasClass(mainCss)) {
                        if (classToRemove && singleSubElem.hasClass(classToRemove)) {
                            singleSubElem.removeClass(classToRemove);
                        }
                        if (classToAdd && !singleSubElem.hasClass(classToAdd)) {
                            singleSubElem.addClass(classToAdd);
                        }
                    }
                }
            }
        }
    });
